import React from 'react';
import {Icon, Tooltip, Typography} from '@bonprix/design-system';
import {TrinityEvents} from '../../tracking/trinity-events.ts';
import {EventObjectType} from '../../tracking/model/EventObjectType.ts';

export default function CartItemAttributes({item, texts, page}) {
    const itemOptionName = item.itemOptionName !== '0' ? item.itemOptionName : null;


    const sendMouseOverEvent = () => {
        const eventAttributes = TrinityEvents.getHoverAttributes('fabric_info', page, EventObjectType.BUTTON);
        TrinityEvents.createAndSendTrinityEvent(1, 'HOVER_CHECKOUT_INFO', eventAttributes);
    };

    const sendOnClickEvent = () => {
        const eventAttributes = TrinityEvents.getClickAttributes('fabric_info', page, EventObjectType.BUTTON);
        TrinityEvents.createAndSendTrinityEvent(1, 'CLICK_CHECKOUT_INFO', eventAttributes);
    };

    const tooltipContent =
        <>
            <Typography component="span">{item.material}</Typography>
        </>;

    return (
        <div className="cart-item-details__attributes">
            <ul className="cart-item-details__attributes-list">
                <li><Typography>{item.styleName}</Typography></li>
                <li><Typography>{item.itemName}</Typography></li>
                <li><Typography>{itemOptionName}</Typography></li>
            </ul>
            <span className="cart-item-details__attributes-material">
                <Tooltip content={tooltipContent}>
                    <span className={'flex gap-2'} onMouseEnter={sendMouseOverEvent} onClick={sendOnClickEvent}>
                        <Typography component="span">{texts.cot_cart_fabric_information}</Typography>
                        <span aria-label="icon">
                            <Icon variant={'hint'} className={'h-5 w-5 inline'} />
                        </span>
                    </span>
                </Tooltip>
            </span>
        </div>
    );
}
